const _ga_id = process.env.VUE_APP_SENTRY_API === 'tianchi' ? 'G-MCQQ3S1KQ5' : 'G-V9YX34R852';

export function gaUploadCustomEvent(id, value) {
  // 如果传入的是object就直接作为参数,如果不是就封装成object
  if (value && typeof value !== 'object') {
    value = { 'value' : value } ;
  }
  gtag('event', id, value);
};

export function setUserConfig(value) {
  // 如果传入的是object就直接作为参数,如果不是就封装成object
  gtag('set', { 'user_id' : value});
};
